module.exports = __webpack_public_path__ + "img/right.09968049.png";